export default __webpack_public_path__ + "static/media/game_3_l.da8ea607.png";